import React, { useEffect, useState } from 'react'

import axios from 'axios'

import { ApiCallPost } from '../../ApiCall/ApiCall'

function AddFourth( {code ,exitadd , naturaleza }) {

    const [value,setValue] = useState( "" )
    const [codigos,setCodigos] = useState( [] )
    const [nameCodigo,setNameCodigo] = useState( "") ;
    const [cero,setCero] = useState( "")

    const [tipo,setTipo] = useState( "R")


    function handleGuardar()
    {

        console.log( "code + value = " + code + value )

        console.log( "Nombre = " + document.getElementById("nombre").value  )

        var obj = {
            nivel : "4" ,
            parent : code ,
            second : code + value ,
            name : document.getElementById("nombre").value ,
            naturaleza : naturaleza ,
            tipo : tipo , // Poner un state
            comment : document.getElementById("comentario").value ,
            dTimeStamp : getFormatDate( new Date() )
        }

        console.log( "handleGuardar =  " + JSON.stringify( obj ) ) ;


        ApiCallPost( "savesecond" , obj )
        .then((result) => {
            console.log( "result " + JSON.stringify( result ) ) ;
            return ;
        })
        .catch((err) => {
            console.log( err ) ;
        })


    }

    function getFormatDate(d) {
        var date = new Date(d);
        var dateStr =
            date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2) + " " +
            ("00" + date.getHours()).slice(-2) + ":" +
            ("00" + date.getMinutes()).slice(-2) + ":" +
            ("00" + date.getSeconds()).slice(-2);
        //console.log(dateStr);
    
        return dateStr;
    }
    

    function handleOnChange( val)
    {
        //console.log( "onChange val = " + JSON.stringify( value ) )

        var value = document.getElementById( "tercer").value ;

        console.log( "Value = " + value ) ;

        setValue( value ) ;



    }



    useEffect(() => {

    axios.get('http://localhost:3004/livefactura/getCodigoAgrupadorSecond/?code=' + code)
    .then((result) => {

        console.log( "Codigo = " + JSON.stringify( result) ) ;

        //fillSelect( result.data ) ;

        setCodigos( result.data )

        setCero( result.data[0].nombre )

        console.log( "******"  + codigos.length )

        //setTimeout( () => { console.log( codigos.length ) }, 2000) // setNameCodigo( codigos[0].nombre ) 

        handleOnChange( result.data[0].codigo)
        
    }).catch((err) => {

        console.log( err ) ;
        
    });

        


    }, [])


    useEffect(() =>{

        console.log( "useEffect")

        if( cero===undefined)
        {return ;}

        console.log( "cero = " + cero ) ;

        setNameCodigo( cero ) ;


    } ,[cero])


    function fillSelect(response)
    {
        var select = document.getElementById('tercer') ;

        while( select.length > 0 )
        {
            select.remove( select.length -1 ) ;
        }
    
        for( var i = 0 ; i < response.length ; i++)
        {
           
    
            var option = document.createElement("option");
            option.value = response[i].codigo;
            option.text =  response[i].codigo  ;

            select.appendChild(option)
    
        }

    }
    

  return (
    

<div className='box-login float-end' style={{ top:'25%' , 
        right:'35%' , backgroundColor :'lightgray' , borderRadius:'20px' ,  
        position : 'fixed' , zIndex : 200}} >

    <div className='d-flex flex-column align-items-center' 
        style={{borderWidth:2 , borderColor :'black' , fontFamily : 'Satoshi-Bold'}}>

        <div>
            <p className='tx-color-purple body-1 mt-2'>Codigo Cuarto Nivel</p>
        </div>

        <div className='display-label-none  w-100'>                    

            <form id='myForm form-2'  style={{color:'black'}}>
        
                <div className="form-outline m-4 mt-1 mb-1 " >
                    <label className="form-label" htmlFor="codigo" >Codigo</label>
                    <input readOnly type="text" id="codigo" value={code}
                    className="form-control" placeholder="Codigo" />
                    
                </div>




                <div className="form-group m-4 mt-1 mb-1">
                    <label for="basic-url">Tercer Nivel</label>
                    <div class="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="tercer1" >{code}</span>
                        </div>
                        <input type="text" className="form-control" onChange={(val) => handleOnChange(val)} 
                            id="tercer" aria-describedby="basic-addon3" />
                    </div>
                </div>



                <div className="form-outline m-4 mt-1 mb-1 " >
                    <label className="form-label" htmlFor="nombre" >Nombre</label>
                    <input  type="text" 
                    id="nombre" className="form-control ms-0" placeholder="Nombre" />
                    
                </div>


                <div className="form-outline m-4 mt-1 mb-1 " >
                    <label className="form-label" htmlFor="comentario" >Comentario</label>
                    <textarea  type="textarea" 
                    id="comentario" className="form-control" placeholder="Comentario" />
                    
                </div>


                {
                    ( naturaleza === "A" || naturaleza === "D" )&& (

                        <div className='m-4 mt-2 mb-1'>
                            <div className='row' >
                                <div className='col-4'>
                                    <p>Naturaleza</p>
                                </div>
                                <div className='col-4'>
                                    <p>{(naturaleza === "A" ? "Acredor" : "Deudor")}</p>
                                </div>
                            </div>
                        </div>
                    )
                }


                <div className='m-4 mt-1 mb-1'>

                <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name='tip' 
                        id="tipor" onChange={() => setTipo('R')}
                        value="option1" checked={tipo==='R'}/>
                    <label className="form-check-label" for="tipor">Resumen</label>
                </div>

                <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name='tip' 
                        id="tipod" onChange={() => setTipo('D')}
                        value="option2" checked={tipo==='D'}/>
                    <label className="form-check-label" for="tipod">Detalle</label>
                </div>



                </div>






                <div className='row'>


                    <div className='col-5'>
                        <button type="button" onClick={handleGuardar} className="button-2 m-4">Guardar</button>
                    </div>
                    <div className='col-1'>

                    </div>
                    

                    <div className='col-4'>
                        <button type="button" onClick={exitadd} className="button-2 m-4">Salir</button>
                    </div>

                    <div className='col-2'>

                    </div>
                    
                </div>
            </form>
        </div>
    </div>
</div>

  )
}

export default AddFourth